<template>
	<v-card v-if="item && item._id" outlined class="text-left" :loading="loading">
		<v-card-title>
			<span class="success--text">$</span>{{ item.mount }} - {{ item.status }}
		</v-card-title>
		<v-card-subtitle>ID: {{ item._id }}</v-card-subtitle>
		<v-card-text>
			<v-row>
				<v-col cols="6">
					<v-text-field
						id="rut-input"
						v-model.trim="rutNotification"
						dense
						outlined
						filled
						small
						label="RUT que realizó pago"
						hint="Ej: 11222333-4"
						required
						:error-messages="rutErrors"
						@input="$v.rutNotification.$touch()"
						@blur="$v.rutNotification.$touch()"
					>
					</v-text-field>
				</v-col>
				<v-col cols="6">
					<v-select
						v-model="status"
						filled
						:loading="loading"
						outlined
						dense
						:items="statuses"
						label="Cambiar estado"
						@change="updateStatus"
					>
					</v-select>
				</v-col>
			</v-row>
		</v-card-text>
		<v-list>
			<v-subheader :class="globalBackground">
				Establecimientos {{ countPlaces }}
			</v-subheader>
			<v-list-item v-for="place in item.places" :key="place._id">
				<v-list-item-content>
					<v-list-item-title>
						{{ place.name }} - {{ place.rut ? place.rut : 'Sin rut' }}
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
		<v-list>
			<v-subheader :class="globalBackground">Personas {{ countPersons }}</v-subheader>
			<v-list-item v-for="person in item.persons" :key="person._id">
				<v-list-item-content>
					<v-list-item-title>
						{{ person.firstName }} {{ person.lastName ? person.lastName : '' }} -
						{{ person.rut ? person.rut : 'Sin rut' }}
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</v-card>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { mapActions } from 'vuex';
import moment from 'moment';

export default {
	name: 'InvoiceCard',
	mixins: [validationMixin],
	props: {
		item: {
			type: Object,
			default: () => {},
		},
		id: {
			type: String,
			default: '',
		},
		cleaning: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			loading: false,
			status: null,
			rutNotification: '',
			statuses: ['REVISIÓN', 'PAGADO', 'NO PAGADO'],
		};
	},
	computed: {
		rutErrors() {
			const errors = [];
			if (!this.$v.rutNotification.$dirty) return errors;
			!this.$v.rutNotification.required && errors.push('El RUT es querido');
			!this.$v.rutNotification.maxLength && errors.push('Máximo 12 caracteres');
			!this.$v.rutNotification.minLength && errors.push('Mínimo 10 caracteres');
			return errors;
		},
		countPlaces() {
			if (this.item && this.item.places) return this.item.places.length;
			return 0;
		},
		countPersons() {
			if (this.item && this.item.persons) return this.item.persons.length;
			return 0;
		},
	},
	watch: {
		item(newValue) {
			if (!this.item.status) this.status = newValue.status;
		},
	},
	methods: {
		updateStatus() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.loading = true;
				this.patchInvoice({
					id: this.item._id,
					status: this.status,
					log:
						moment().format('DD-MM-YYYY') +
						': Se solicito revisión con rut ' +
						this.rutNotification,
				}).then(() => {
					this.cleaning();
					this.fetchInvoiceByIdUser(this.id);
					this.loading = false;
				});
			}
		},
		...mapActions({
			patchInvoice: 'User/patchInvoice',
			fetchInvoiceByIdUser: 'User/fetchInvoiceByIdUser',
		}),
	},
	validations: {
		rutNotification: {
			required,
			minLength: minLength(10),
			maxLength: maxLength(12),
		},
	},
};
</script>
